import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const fetchTotalDue = async (account: any) => {
  let acc_no = "";
  let no = account?.toString().length;

  switch (no) {
    case 1:
      acc_no = `0000${account}`;
      break;
    case 2:
      acc_no = `000${account}`;
      break;
    case 3:
      acc_no = `00${account}`;
      break;
    case 4:
      acc_no = `0${account}`;
      break;
    default:
      acc_no = `${account}`;
  }

  const result = await fetch(`${REACT_APP_ARPS_BASE_URL}/statements/${acc_no}/due`);
  const sites = await result.json();
  return sites;
};

export default fetchTotalDue;
